class rollticketSpecCtrl {
    constructor($scope, httpRequest, initSortService) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
        }

        // 表头排序
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            $scope.queryList()
        }
        // 按钮使能
        $scope.disableSw = false

        $scope.queryList = function queryList() {
            httpRequest.post_getSysRollticketSpecList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()

        $scope.swChange = function (state, bankObj) {
            const obj = bankObj
            obj.state = state
            $scope.disableSw = true
            let msg = ''

            if (obj.state) {
                msg = '启用成功'
            } else {
                msg = '已禁用'
            }

            httpRequest.get_updateRollticketStates({
                specId: obj.specId,
                state,
            }, msg).then((res) => {
                $scope.disableSw = false
            }, (err) => {
                $scope.disableSw = false
                $scope.queryList()
            })
        }
    }
}

rollticketSpecCtrl.$inject = ['$scope', 'httpRequest', 'initSortService']
export default rollticketSpecCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/rollticketSpec/rollticketSpecCtrl.js